<!--
@create date 2023-10-31
@desc m08f.phomemo.com
-->
<template>
  <div class="m08f-guide2-div">
    <div class="scroll-items-div">
      <ul>
        <li
          :class="
            clickName === 'howToVideosRef'
              ? 'every-click-item active-select-item'
              : 'every-click-item'
          "
          @click="turnToItem('howToVideosRef')"
        >
          HOW-TO VIDEOS
        </li>
        <li
          :class="
            clickName === 'driversRef'
              ? 'every-click-item active-select-item'
              : 'every-click-item'
          "
          @click="turnToItem('driversRef')"
        >
          DRIVERS
        </li>
        <li
          :class="
            clickName === 'appDownloadRef'
              ? 'every-click-item active-select-item'
              : 'every-click-item'
          "
          @click="turnToItem('appDownloadRef')"
        >
          APP
        </li>
        <li
          :class="
            clickName === 'faqRef'
              ? 'every-click-item active-select-item'
              : 'every-click-item'
          "
          @click="turnToItem('faqRef')"
        >
          FAQ
        </li>
      </ul>
    </div>
    <div class="topContainerDivEx tp81TopContainer">
      <h1>TP87 Tattoo Stencil Printer Support</h1>
      <div class="productDiv">
        <div class="leftDiv">
          <img
            src="https://oss.qu-in.top/printerFiles/phomemo/TPX/TP87.png"
            style="margin: 10px auto; width: 200px"
          />
        </div>
        <div class="rightDiv" style="padding-top: 100px">
          <p>
            If you want to view the Manuals For TP87, Please click below Link:
          </p>
          <div class="linkDiv" ref="howToVideosRef">
            <a
              @click="
                () => {
                  refreshRecord({ key: 'TP87_tattoo_suppliesSales' });
                  window.open(
                    'https://oss.qu-in.top/printerFiles/phomemo/TPX/TP87-EN.jpg'
                  );
                }
              "
              target="_blank"
              title="Click to learn more"
              >TP87 Manual for EN</a
            >
            |
            <a
              @click="
                () => {
                  refreshRecord({ key: 'TP87_tattoo_suppliesSales' });
                  window.open(
                    'https://oss.qu-in.top/printerFiles/phomemo/TPX/TP87-JA.jpg'
                  );
                }
              "
              target="_blank"
              title="Click to learn more"
              >TP87 Manual for JA</a
            >
            |
            <a
              @click="
                () => {
                  refreshRecord({ key: 'TP87_tattoo_suppliesSales' });
                  window.open(
                    'https://oss.qu-in.top/printerFiles/phomemo/TPX/TP87-DE.jpg'
                  );
                }
              "
              target="_blank"
              title="Click to learn more"
              >TP87 Manual for DE</a
            >
          </div>
        </div>
      </div>
    </div>

    <div class="howToVideosDiv">
      <div class="videoTitle">
        <img
          src="https://doc.labelife.net/upload/documents/tattoo/videosIcon.png"
          style="margin: 0"
        />
        <div class="textContainer">HOW-TO VIDEOS</div>
      </div>
      <br />
      <div class="videosDivE">
        <div class="leftDiv">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/2235.png?v=1644832141"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a class="a-link">For Mac</a>
        </div>
        <div class="centerDiv">
          <p>MacOS 10.14</p>
          <p>MacOS 10.15</p>
          <p>MacOS 10.11</p>
          <p>MacOS 12</p>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            poster=""
            style="width: 100%"
            id="TP87_tattoo_macVideo"
          >
            <source
              src="https://web-video-1317518395.cos.na-ashburn.myqcloud.com/guideVideos/TP81/MAC%E7%89%88%E6%9C%AC.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>

      <hr
        style="color: rgba(51, 61, 71, 0.3); margin: 0 8%; margin-bottom: 6px"
      />
      <div class="videosDivE">
        <div class="leftDiv">
          <img
            class="videoLogoImg"
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/windows-phone-logo-topic.png?v=1644832318"
            style="display: block; margin: 0 auto"
          />
          <a class="a-link">For Windows</a>
        </div>
        <div class="centerDiv">
          <p>Windows 7 (32 and 64 bit)</p>
          <p>Windows 8 (32 and 64 bit)</p>
          <p>Windows 10 (32 and 64 bit)</p>
          <p>Windows 11 (64 bit)</p>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            poster=""
            style="width: 100%"
            id="TP87_tattoo_windowsVideo"
          >
            <source
              src="https://web-video-1317518395.cos.na-ashburn.myqcloud.com/guideVideos/TP81/Windows%E7%89%88%E6%9C%AC.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>

      <hr
        style="color: rgba(51, 61, 71, 0.3); margin: 0 8%; margin-bottom: 6px"
      />

      <div class="videosDivE">
        <div class="leftDiv" style="padding-top: 3%">
          <img
            src="https://doc.labelife.net/upload/documents/tattoo/chrome.png"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a class="a-link">For Chrome OS</a>
        </div>
        <div class="centerDiv" style="padding-top: 6%">
          <p>Download Extension For Chrome OS</p>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 100%"
            id="TP87_chromeVideo"
          >
            <source
              src="https://web-video-1317518395.cos.na-ashburn.myqcloud.com/guideVideos/M08F/Chorme%20OS.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>

      <hr
        style="color: rgba(51, 61, 71, 0.3); margin: 0 8%; margin-bottom: 6px"
      />
      <div class="videosDivE">
        <div class="leftDiv">
          <img
            src="https://doc.labelife.net/upload/documents/tattoo/pm246sLinux.png"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a class="a-link">For Linux</a>
        </div>
        <div class="centerDiv" style="padding-top: 5%">
          <p>Download Driver For Linux System</p>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 100%"
            id="TP87_linuxVideo"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/pm246s_linux.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>
    </div>

    <div class="howToVideosDiv" ref="driversRef">
      <div class="videoTitle">
        <img
          src="https://doc.labelife.net/upload/documents/tattoo/driversIcon.png"
          style="margin: 0"
        />
        <div class="textContainer">DRIVERS</div>
      </div>
      <div class="downloadTitleBar">
        <span>TP87 series Driver setup package (Windows)</span>
        <div
          class="downloadBtnNew"
          title="Click to download"
          @click="
            () => {
              refreshRecord({ key: 'TP87_tattoo_windowsDrivers' });
              window.open(
                'https://oss.qu-in.top/printerFiles/phomemo/TPX/QY_Printer Driver Setup 2.1.0.003.exe'
              );
            }
          "
        >
          DOWNLOAD
          <img
            src="https://doc.labelife.net/upload/documents/tattoo/downloadIconMini.png"
          />
        </div>
        <span class="showSizeDiv" title="File Size">(3.64 MB)</span>
      </div>
      <div class="downloadText">
        <p>
          OPERATING SYSTEM: Windows 7, Windows 8, Windows 10(32 and 64 bit)
          Windows 11(64 bit)
        </p>
      </div>
      <!-- <br v-show="!isMobile()" />
      <hr style="
          color: rgba(51, 61, 71, 0.3);
          margin: 0 1% 0 4%;
          margin-bottom: 6px;
        " />
      <div class="downloadTitleBar">
        <span>TP87 series Driver setup package (Windows ARM)</span>
        <div class="downloadBtnNew" title="Click to download" style="top: 20px" @click="() => {
          refreshRecord({ key: 'TP87_tattoo_ARMDrivers' });
          window.open(
            'https://oss.qu-in.life/Tianyi/QY_Printer_Driver_WIN-ARM_EN.zip'
          );
        }
          ">
          DOWNLOAD
          <img src="https://doc.labelife.net/upload/documents/tattoo/downloadIconMini.png" />
        </div>
        <span class="showSizeDiv" title="File Size" style="top: 31px">(1.31 MB)</span>
      </div> -->
      <br v-show="!isMobile()" />
      <br v-show="!isMobile()" />
      <hr
        style="
          color: rgba(51, 61, 71, 0.3);
          margin: 0 1% 0 4%;
          margin-bottom: 6px;
        "
      />

      <div class="downloadTitleBar">
        <span>TP87 series Driver setup package (Mac)</span>
        <div
          class="downloadBtnNew"
          title="Click to download"
          @click="
            () => {
              refreshRecord({ key: 'TP87_tattoo_macDrivers' });
              window.open(
                'https://oss.qu-in.top/printerFiles/phomemo/TPX/QY_Printer-2.1.0.004.dmg'
              );
            }
          "
        >
          DOWNLOAD
          <img
            src="https://doc.labelife.net/upload/documents/tattoo/downloadIconMini.png"
          />
        </div>
        <span class="showSizeDiv" title="File Size">(14.5 MB)</span>
      </div>
      <div class="downloadText">
        <p>OPERATING SYSTEM: macOS 10.14, macOS 10.15, macOS 10.11, macOS 12</p>
      </div>

      <br v-show="!isMobile()" />
      <hr
        style="
          color: rgba(51, 61, 71, 0.3);
          margin: 0 1% 0 4%;
          margin-bottom: 6px;
        "
      />

      <div class="downloadTitleBar">
        <span>TP87 Series Extension setup (Chrome OS)</span>
        <div
          class="downloadBtnNew"
          title="Click to download"
          style="top: 20px"
          @click="
            () => {
              refreshRecord({ key: 'TP87_chromeDrivers' });
              window.open(
                'https://chrome.google.com/webstore/detail/labelife/fahkjfnppokdemlfodklgmdklmcllidl'
              );
            }
          "
        >
          CLICK HERE
          <img
            src="https://doc.labelife.net/upload/documents/tattoo/downloadIconMini.png"
          />
        </div>
        <!-- <span class="showSizeDiv" title="File Size">(528 KiB)</span> -->
      </div>
      <br v-show="!isMobile()" />
      <br v-show="!isMobile()" />
      <hr
        style="
          color: rgba(51, 61, 71, 0.3);
          margin: 0 1% 0 4%;
          margin-bottom: 6px;
        "
      />

      <div class="downloadTitleBar">
        <span>TP87 series Driver setup package (Linux)</span>
        <div
          class="downloadBtnNew"
          title="Click to download"
          style="top: 20px"
          @click="
            () => {
              refreshRecord({ key: 'TP87_linuxDrivers' });
              window.open(
                'https://oss.qu-in.life/Phomemo/QY_Printer_Driver_Linux.zip'
              );
            }
          "
        >
          DOWNLOAD
          <img
            src="https://doc.labelife.net/upload/documents/tattoo/downloadIconMini.png"
          />
        </div>
        <span class="showSizeDiv" title="File Size" style="top: 31px"
          >(351 KB)</span
        >
      </div>
    </div>

    <div class="howToVideosDiv" style="margin-top: 40px" ref="appDownloadRef">
      <div class="videoTitle">
        <img
          src="https://doc.labelife.net/upload/documents/tattoo/driversIcon.png"
          style="margin: 0"
        />
        <div class="textContainer">APP</div>
      </div>
      <div class="appDownloadContainer">
        <div class="everyItemArea">
          <img :src="appDownIcon" style="max-width: 150px" />
          <h3>Phomemo APP - IOS</h3>
          <p>Easily print from your iOS device with the Phomemo App</p>
          <p>
            <a
              @click="
                () => {
                  refreshRecord({ key: 'TP87_tattoo_AppStore' });
                  window.open(
                    'https://apps.apple.com/us/app/phomemo/id1456102145'
                  );
                }
              "
              target="_blank"
              title="Click to download"
              >LEARN MORE</a
            >
          </p>
        </div>
        <div class="dividerLineDiv"></div>
        <div class="everyItemArea">
          <img :src="appDownIcon" style="max-width: 150px" />
          <h3>Phomemo APP - Android</h3>
          <p>Easily print from your Android device with the Phomemo App</p>
          <p>
            <a
              @click="
                () => {
                  refreshRecord({ key: 'TP87_tattoo_GooglePlay' });
                  window.open(
                    'https://play.google.com/store/apps/details?id=com.quyin.phomemo'
                  );
                }
              "
              target="_blank"
              title="Click to download"
              >LEARN MORE</a
            >
          </p>
        </div>
      </div>
    </div>

    <div class="howToVideosDiv faqBarDiv" ref="faqRef">
      <div class="videoTitle">
        <img
          src="https://doc.labelife.net/upload/documents/tattoo/faqsIcon.png"
          style="margin: 0"
        />
        <div class="textContainer" title="Frequently Asked Questions">FAQ</div>
      </div>
      <div class="faq-content-area" style="margin-top: 30px">
        <div class="faq-container">
          <div
            class="faq-item"
            v-for="(item, index) in faqDataApp"
            :key="index"
          >
            <div class="faq-title" @click="clickQuestion2(item, index)">
              <span v-text="item.title"></span>
              <img
                src="https://doc.labelife.net/upload/documents/tattoo/delIconImg.png"
                class="downArrow"
                v-show="activeQuestion2.index === index"
              />
              <img
                src="https://doc.labelife.net/upload/documents/tattoo/addIconImg.png"
                class="downArrow"
                v-show="activeQuestion2.index !== index"
              />
            </div>
            <div class="faq-scroll-area">
              <div
                class="faq-content"
                v-show="activeQuestion2.index === index"
                v-for="child in item.details"
              >
                <div class="content-title" v-html="child.theme"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--   联系方式 -->
    <div class="customServiceDiv">
      <div class="everyRow">
        Email：
        <a
          @click="
            () => {
              refreshRecord({ key: 'TP87_tattoo_email' });
              window.open('mailto:support@phomemo.com');
            }
          "
          >support@phomemo.com</a
        >
      </div>
      <div class="everyRow">Tel：+1 855 957 5321(US ONLY)</div>
      <div class="everyRow">WhatsApp：+86 15338193665</div>
    </div>

    <div class="back-to-top-div">
      <a @click="backTop"><img :src="toTopIcon" /><br />Back to top</a>
    </div>
  </div>
</template>

<script>
import { refreshRecord } from "@/util.js";
import { tp87Info } from "./dataConfig.js";
const isMobile = () => {
  // 返回true为移动端，否则为pc端
  if (!window.navigator) return true;
  const flag = window.navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag ? true : false;
};

export default {
  name: "TP87",
  props: {},
  data() {
    return {
      faqDataApp: tp87Info.faqData,
      activeQuestion2: {},
      isMobile,
      window,
      appDownIcon: require("@/assets/appDownIcon.jpg"),
      clickName: "",
      toTopIcon: require("@/assets/toTopIcon.png"),
      refreshRecord,
    };
  },
  mounted() {
    this.listenVideo("TP87_tattoo_macVideo");
    this.listenVideo("TP87_tattoo_windowsVideo");
    // this.listenVideo("TP87_tattoo_chromeVideo");
    // this.listenVideo("TP87_tattoo_linuxVideo");
    // this.listenVideo("TP87_tattoo_APPVideo");
  },
  methods: {
    listenVideo(videoId) {
      document.getElementById(videoId).addEventListener("play", function () {
        // console.log("视频开始播放了！");
        refreshRecord({ key: videoId });
      });
    },
    clickQuestion2(item = {}, index) {
      const { activeQuestion2 } = this;
      if (
        activeQuestion2.index === undefined ||
        activeQuestion2.index !== index
      ) {
        refreshRecord({ key: "TP87_tattoo_FAQ" + (index + 1) });
        this.activeQuestion2 = { ...item, index };
      } else this.activeQuestion2 = {};
    },
    backTop() {
      const scrollToTop = () => {
        const c = document.documentElement.scrollTop || document.body.scrollTop;
        if (c > 0) {
          window.requestAnimationFrame(scrollToTop);
          window.scrollTo(0, c - c / 8);
        }
      };
      scrollToTop();
      this.clickName = "";
    },

    turnToItem(refName = "") {
      const ref = this.$refs[refName];
      this.clickName = refName;
      if (ref && ref.scrollIntoView) ref.scrollIntoView();
    },
  },
};
</script>

<style lang="less" src="./m08f_2.less" />



// WEBPACK FOOTER //
// src/view/guides/TP87.vue